


















import { Component, Vue, Prop, Model } from "vue-property-decorator";
import { SigninPayload } from "./interfaces/payload.interface";
import SigninForm from "./Form.vue";
import Auth from "@/store/auth";

@Component({
  components: {
    "signin-form": SigninForm
  }
})
export default class Signin extends Vue {
  isLoading: boolean = false;
  isOtpRequired: boolean = false;
  error: string = "";
  refPin: string = "";
  sessionId: number = 0;
  async onSubmit(form: SigninPayload) {
    if (form.code) {
      this.onVerfiyOtp(form);
    } else {
      this.onSignin(form);
    }
  }

  async onVerfiyOtp(form: SigninPayload) {
    this.error = "";
    this.isLoading = true;
    try {
      await Auth.confirmOtp({
        code: form.code,
        pin: this.refPin,
        session_id: this.sessionId
      });
      this.$router.push('/');
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
    }
  }

  async onSignin(form: SigninPayload) {
    this.error = "";
    this.isLoading = true;
    try {
      const result: any = await Auth.signin(form);
      if (result.pin) {
        this.isOtpRequired = true;
        this.refPin = result.pin;
        this.sessionId = result.sessionId;
      }
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
    }
  }

  async onCancel() { }
}
